/* Seed data ported from the old admin verbatim. Replaced by API calls
   later; shape stays identical so wiring is a one-line swap per fetch.

   Note on PROPERTIES: each row carries the rich wizard payload (configs,
   amenities, media, etc.) PLUS the flat display fields the OLD admin
   list expects — featured, views, inquiries. Listing uses the flat
   fields; the wizard reads/writes the rich ones. */

export const CITIES = [
  { id: "c1", name: "Pune", state: "Maharashtra", localities: 9, properties: 17, active: true },
  { id: "c2", name: "Mumbai", state: "Maharashtra", localities: 0, properties: 0, active: false },
  { id: "c3", name: "Bengaluru", state: "Karnataka", localities: 0, properties: 0, active: false },
];

export const LOCALITIES = [
  { id: "loc1", name: "Baner",      city: "Pune", pincode: "411045", properties: 4, projects: 3, active: true },
  { id: "loc2", name: "Hinjewadi",  city: "Pune", pincode: "411057", properties: 3, projects: 2, active: true },
  { id: "loc3", name: "Wakad",      city: "Pune", pincode: "411057", properties: 2, projects: 1, active: true },
  { id: "loc4", name: "Kothrud",    city: "Pune", pincode: "411038", properties: 1, projects: 1, active: true },
  { id: "loc5", name: "Aundh",      city: "Pune", pincode: "411007", properties: 2, projects: 1, active: false },
  { id: "loc6", name: "Magarpatta", city: "Pune", pincode: "411013", properties: 0, projects: 0, active: false },
];

export const BUILDERS = [
  {
    id: "b1",
    name: "Godrej Properties",
    wordmark: "Godrej",
    tagline: "Properties",
    locations: ["Pune", "Mumbai", "Bengaluru"],
    experience: "27+ yrs",
    totalProjects: 89,
    happyFamilies: "12,000+",
    about: "Godrej Properties brings the Godrej Group philosophy of innovation, sustainability and excellence to real estate, developing landmark residential and commercial projects across India's major cities.",
  },
  {
    id: "b2",
    name: "Lodha Group",
    wordmark: "Lodha",
    tagline: "Building a better life",
    locations: ["Pune", "Mumbai"],
    experience: "40+ yrs",
    totalProjects: 120,
    happyFamilies: "30,000+",
    about: "Lodha is among India's premier real estate developers, focused on creating landmark residences that blend luxury, design and lasting value.",
  },
  {
    id: "b3",
    name: "Kolte Patil",
    wordmark: "Kolte-Patil",
    tagline: "Creating landmarks",
    locations: ["Pune", "Bengaluru"],
    experience: "32+ yrs",
    totalProjects: 65,
    happyFamilies: "20,000+",
    about: "Kolte-Patil Developers has been creating iconic landmarks across Pune for over three decades, with a reputation for on-time delivery and quality construction.",
  },
];

export const SALES_TEAM = [
  {
    id: "s1",
    name: "Sarika K.",
    email: "sarika@abhighar.com",
    phone: "9604551699",
    active: 12,
    profile: {
      fathersName: "Krishnan Kothari", dob: "1995-08-14", emergencyContact: "9325554477", gender: "female",
      aadharNumber: "5234 8821 9056", panNumber: "EBMPS8356C", employeeCodeId: "AG-2024-001",
      department: "Sales", joiningDate: "2024-03-15", salary: 32000,
      permanentAddress: "Flat 304, Vrindavan Residency, Aundh, Pune, MH 411007",
      currentAddress: "Flat 304, Vrindavan Residency, Aundh, Pune, MH 411007",
    },
  },
  {
    id: "s2",
    name: "Kedar Naik",
    email: "kedar@abhighar.com",
    phone: "9823004411",
    active: 9,
    profile: {
      fathersName: "Ravindra Naik", dob: "1992-02-22", emergencyContact: "9876543210", gender: "male",
      aadharNumber: "8841 2390 7741", panNumber: "AKHPN4477L", employeeCodeId: "AG-2024-002",
      department: "Sales", joiningDate: "2024-05-02", salary: 35000,
      permanentAddress: "1224, Sadashiv Peth, Pune, MH 411030",
      currentAddress: "B-12 Mahalaxmi Apartments, Baner, Pune, MH 411045",
    },
  },
  {
    id: "s3",
    name: "Riya Mehta",
    email: "riya@abhighar.com",
    phone: "9920334455",
    active: 14,
    profile: {
      fathersName: "Anil Mehta", dob: "1996-11-09", emergencyContact: "9920112233", gender: "female",
      aadharNumber: "2256 7790 3344", panNumber: "BMKPM2233F", employeeCodeId: "AG-2024-003",
      department: "Sales", joiningDate: "2024-06-20", salary: 30000,
      permanentAddress: "Plot 47, Vile Parle West, Mumbai, MH 400056",
      currentAddress: "Anand Park PG, Wakad, Pune, MH 411057",
    },
  },
  {
    id: "s4",
    name: "Aditya Rao",
    email: "aditya@abhighar.com",
    phone: "9011224488",
    active: 7,
    profile: {
      fathersName: "Suresh Rao", dob: "1993-06-30", emergencyContact: "9011998877", gender: "male",
      aadharNumber: "7712 4456 8821", panNumber: "CKPRA8821J", employeeCodeId: "AG-2024-004",
      department: "Sales", joiningDate: "2024-08-10", salary: 33000,
      permanentAddress: "Old No. 22, T. Nagar, Chennai, TN 600017",
      currentAddress: "Kalyani Nagar PG, Pune, MH 411006",
    },
  },
];

/* Property amenity presets — what the wizard offers as one-click chips. */
export const AMENITY_PRESETS = [
  "Swimming Pool", "Gym", "Clubhouse", "Kids Play Area", "24x7 Security",
  "Wide Internal Roads", "Water Supply", "Underground Drainage", "Street Lights",
  "Landscaped Parks", "Electricity", "Clear Titles & Legal",
  "Power Backup", "Lift", "Indoor Games", "Multipurpose Hall", "Jogging Track",
  "Landscaped Garden", "Yoga Deck", "Covered Parking", "Visitor Parking",
  "Rainwater Harvesting", "EV Charging", "CCTV Surveillance", "Intercom",
  "Banquet Hall", "Library", "Mini Theatre", "Spa", "Squash Court",
  "Tennis Court", "Basketball Court", "Cricket Pitch", "Amphitheatre",
];

export const PROPERTY_TYPES = [
  "Apartment", "Villa", "Plot", "Duplex", "Studio Apartment", "Commercial",
];

export const PROPERTY_STATUSES = ["draft", "published", "archived"];

export const PROPERTIES = [
  {
    id: "p1",
    title: "Godrej Hill Retreat",
    slug: "godrej-hill-retreat-mahalunge",
    builderId: "b1",
    localityId: "loc1",
    city: "Pune",
    propertyType: "Apartment",
    status: "published",
    featured: true,
    views: 1240,
    inquiries: 38,
    reraId: "P52100049832",
    possessionDate: "2026-12-01",
    shortDescription: "Premium 2 & 3 BHK apartments at the foothills of Mahalunge with panoramic hill views.",
    fullDescription: "Set on a 9-acre landscaped campus with three towers wrapped around a central greens, Godrej Hill Retreat brings resort-style living to the upper edge of West Pune. Floor-to-ceiling windows in every home, double-height clubhouse, and direct connectivity to Hinjewadi via the Mahalunge spine road.",
    coverImage: null,
    gallery: [],
    floorPlans: [],
    configs: [
      { id: "cfg1", bhk: "2 BHK", carpetArea: 780,  areaUnit: "sq_ft", price: 8500000,  priceLabel: "₹85L onwards", units: 60 },
      { id: "cfg2", bhk: "3 BHK", carpetArea: 1100, areaUnit: "sq_ft", price: 12500000, priceLabel: "₹1.25Cr onwards", units: 40 },
    ],
    amenities: ["Swimming Pool", "Gym", "Clubhouse", "Kids Play Area", "24x7 Security", "Power Backup", "Landscaped Garden"],
    specialOffer: { enabled: true, title: "Pre-launch Pricing", description: "Lock in pre-launch rates with ₹1L token amount. Limited inventory.", validTill: "2026-08-31" },
    location: {
      address: "Survey No. 14, Mahalunge, Pune - 411045",
      lat: 18.6041, lng: 73.7762,
      nearby: [
        { id: "n1", name: "Hinjewadi IT Park",  type: "Office Hub", distance: "8 km" },
        { id: "n2", name: "Balewadi Stadium",   type: "Sports",     distance: "5 km" },
        { id: "n3", name: "Symbiosis Vishwabhavan", type: "Education", distance: "6 km" },
      ],
    },
    seo: {
      metaTitle: "Godrej Hill Retreat — Premium 2 & 3 BHK in Mahalunge, Pune",
      metaDescription: "Discover resort-style living at Godrej Hill Retreat, Mahalunge. 2 & 3 BHK with panoramic hill views, starting ₹85L. RERA P52100049832.",
      focusKeyword: "2 BHK in Mahalunge",
    },
    createdAt: "2024-08-15", updatedAt: "2025-11-02",
  },
  {
    id: "p2",
    title: "Lodha Splendora",
    slug: "lodha-splendora-hinjewadi",
    builderId: "b2",
    localityId: "loc2",
    city: "Pune",
    propertyType: "Apartment",
    status: "published",
    featured: false,
    views: 980,
    inquiries: 22,
    reraId: "P52100051209",
    possessionDate: "2027-03-01",
    shortDescription: "Luxury 2, 3 & 4 BHK residences in the heart of Hinjewadi Phase 1, minutes from Tier-1 tech campuses.",
    fullDescription: "Five towers across 14 acres, world-class amenities including an Olympic-size pool, three-storey clubhouse, and dedicated co-working space. The new flagship of Lodha in West Pune.",
    coverImage: null,
    gallery: [],
    floorPlans: [],
    configs: [
      { id: "cfg3", bhk: "2 BHK", carpetArea: 850,  areaUnit: "sq_ft", price: 9500000,  priceLabel: "₹95L onwards", units: 80 },
      { id: "cfg4", bhk: "3 BHK", carpetArea: 1240, areaUnit: "sq_ft", price: 14000000, priceLabel: "₹1.4Cr onwards", units: 60 },
      { id: "cfg5", bhk: "4 BHK", carpetArea: 1850, areaUnit: "sq_ft", price: 22500000, priceLabel: "₹2.25Cr onwards", units: 20 },
    ],
    amenities: ["Swimming Pool", "Gym", "Clubhouse", "Kids Play Area", "24x7 Security", "Banquet Hall", "Tennis Court", "Squash Court", "Mini Theatre", "EV Charging"],
    specialOffer: { enabled: false, title: "", description: "", validTill: "" },
    location: {
      address: "Phase 1, Hinjewadi, Pune - 411057",
      lat: 18.5912, lng: 73.7389,
      nearby: [
        { id: "n4", name: "Wipro Campus",       type: "Office Hub", distance: "1 km" },
        { id: "n5", name: "Infosys Phase 1",    type: "Office Hub", distance: "2 km" },
        { id: "n6", name: "Hinjewadi Metro",    type: "Transit",    distance: "3 km" },
      ],
    },
    seo: {
      metaTitle: "Lodha Splendora — Luxury 2/3/4 BHK in Hinjewadi Phase 1",
      metaDescription: "Live at Lodha Splendora, Hinjewadi Phase 1. 2/3/4 BHK luxury residences from ₹95L. Olympic pool, three-storey clubhouse.",
      focusKeyword: "3 BHK in Hinjewadi",
    },
    createdAt: "2024-09-22", updatedAt: "2025-12-10",
  },
  {
    id: "p3",
    title: "Kolte Patil Life Republic — Atmos",
    slug: "kolte-patil-life-republic-atmos",
    builderId: "b3",
    localityId: "loc2",
    city: "Pune",
    propertyType: "Apartment",
    status: "draft",
    featured: true,
    views: 0,
    inquiries: 0,
    reraId: "P52100052741",
    possessionDate: "2027-09-01",
    shortDescription: "Compact 1 & 2 BHK homes inside the 400-acre Life Republic township in Hinjewadi Phase 3.",
    fullDescription: "Phase 9 of the masterplanned Life Republic township. Walk-to-work convenience to Hinjewadi Phase 3 campuses, in-township school, retail spine and hospital.",
    coverImage: null,
    gallery: [],
    floorPlans: [],
    configs: [
      { id: "cfg6", bhk: "1 BHK", carpetArea: 480, areaUnit: "sq_ft", price: 6500000, priceLabel: "₹65L onwards", units: 120 },
      { id: "cfg7", bhk: "2 BHK", carpetArea: 720, areaUnit: "sq_ft", price: 9200000, priceLabel: "₹92L onwards", units: 80 },
    ],
    amenities: ["Swimming Pool", "Gym", "Kids Play Area", "24x7 Security", "Jogging Track", "Yoga Deck"],
    specialOffer: { enabled: false, title: "", description: "", validTill: "" },
    location: {
      address: "Marunji, Hinjewadi Phase 3, Pune - 411057",
      lat: 18.6235, lng: 73.7088,
      nearby: [
        { id: "n7", name: "Hinjewadi Phase 3", type: "Office Hub", distance: "2 km" },
      ],
    },
    seo: { metaTitle: "", metaDescription: "", focusKeyword: "" },
    createdAt: "2025-01-08", updatedAt: "2025-01-08",
  },
];
